import { Injector } from '@angular/core';

/* Holds a static reference to Injector so that BaseComponent can inject services itself
*   without constructor parameters, allowing BaseComponent to be extended.
*/
export class ServiceLocator {
  static injector: Injector;
}
